if ('MutationObserver' in window) {
    const nonceElement = document.querySelector('input[name="__uiid"]');

    if (nonceElement != null) {
        const nonce = nonceElement.value;
        const targetNode = document.querySelector('html');
        const config = { attributes: false, childList: true, subtree: false };

        const callback = function (mutationsList, observer) {
            mutationsList.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    if (mutation.addedNodes && mutation.addedNodes.length) {
                        let nodes = mutation.addedNodes;
                        for (var i = 0; i < nodes.length; i++) {
                            if (nodes[i].nodeName.toLowerCase() === 'script' && !nodes[i].attributes.nonce && nodes[i].attributes.src && nodes[i].attributes.src.length > 0) {
                                nodes[i].setAttribute('nonce', nonce);
                            }
                        }
                    }
                }
            })
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
}

setTimeout(function () {
    const nonceNode = document.querySelector('input[name="__uiid"]');
    if (nonceNode != null)
        nonceNode.parentNode.removeChild(nonceNode);
}, 3000);

// Handle job search form here
const jobSearchForm = document.querySelector('#form');

if (jobSearchForm != null) {
    function handleFormSubmit(event) {
        event.currentTarget.querySelector('button').disabled = true;
        event.currentTarget.querySelector('button').classList.add('loading');
    }

    jobSearchForm.addEventListener('submit', handleFormSubmit);
    jobSearchForm.querySelectorAll('select')

    var selectControls = jobSearchForm.querySelectorAll('select');

    [].forEach.call(selectControls, function (select) {
        select.addEventListener("change", () => {

            let event;
            if (window.CustomEvent) {
                event = new CustomEvent('submit', {});
            } else {
                event = document.createEvent('CustomEvent');
                event.initCustomEvent('submit', true, true, {});
            }

            jobSearchForm.dispatchEvent(event);
            jobSearchForm.submit();
        })
    });
}